import PasswordReset from '@/components/AriseAuth/pages/PasswordReset';

export default function PasswordResetPage() {
    return <PasswordReset />;
}
